export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_day_113.6d4d73ae.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};